import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

const propTypes = {
  companyThirdPartyScript: PropTypes.string,
}

const defaultProps = {
  companyThirdPartyScript: undefined,
}

const mapStateToProps = state => ({
  companyThirdPartyScript: state.careers.company.thirdPartyScript,
})

// https://stackoverflow.com/questions/1197575/can-scripts-be-inserted-with-innerhtml
// user Adnan Korkmaz posts this function which he says he uses for his ad server
// o: container to set the innerHTML
// html: html text to set.
function setHTML(o, html) {
  // Generate a parseable object with the html:
  const dv = document.createElement('div')
  dv.innerHTML = html

  // Handle edge case where innerHTML contains no tags, just text:
  if (dv.children.length === 0) {
    o.innerHTML = html
    return
  }

  for (let i = 0; i < dv.children.length; i += 1) {
    const c = dv.children[i]

    // n: new node with the same type as c
    const n = document.createElement(c.nodeName)
    n.setAttribute('name', 'third-party-scripts-element')

    // copy all attributes from c to n
    for (let j = 0; j < c.attributes.length; j += 1) {
      n.setAttribute(c.attributes[j].nodeName, c.attributes[j].nodeValue)
    }

    // If current node is a leaf, just copy the appropriate property (text or innerHTML)
    if (c.children.length === 0) {
      switch (c.nodeName) {
        case 'SCRIPT':
          if (c.text) {
            n.text = c.text
          }
          break
        default:
          if (c.innerHTML) {
            n.innerHTML = c.innerHTML
          }
          break
      }
    } else setHTML(n, c.innerHTML) // If current node has sub nodes, call itself recursively:

    o.appendChild(n)
  }
}

export class ThirdPartyScripts extends React.Component {
  componentDidMount() {
    const { companyThirdPartyScript } = this.props
    const existingScript = document.getElementsByName('third-party-scripts-element')

    if (existingScript.length <= 0 && companyThirdPartyScript) {
      setHTML(document.head, companyThirdPartyScript)
    }

    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      })
    }
  }

  render() {
    return null
  }
}

ThirdPartyScripts.propTypes = propTypes
ThirdPartyScripts.defaultProps = defaultProps

export default connect(mapStateToProps)(ThirdPartyScripts)
